import axios from "axios";
import AWS from "aws-sdk";

AWS.config.update({
  accessKeyId: "AKIA3JUEYN6PTLQ2KZNW",
  secretAccessKey: "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",
  region: "ap-south-1",
});
const s3 = new AWS.S3();

export const getBase64Image = async (img) => {
  // temp veriable which store image from url

  // image to base64 covert
  let image = await axios
    .get(img, { responseType: "arraybuffer" })
    .catch(function (error) {
      console.log("error while fetching image ", img, error);
    });
  if (image && image?.data) {
    let raw = Buffer.from(image.data).toString("base64");
    return "data:" + image.headers["content-type"] + ";base64," + raw;
  } else {
    console.log("catch image error");
    return "";
  }
};

export const getImageFromS3 = async (bucket, objectKey) => {
  try {
    const params = {
      Bucket: bucket,
      Key: objectKey,
    };

    const data = await s3.getObject(params).promise();
    let image = Buffer.from(data.Body).toString("base64");
    image = "data:" + data.ContentType + ";base64," + image;

    return image;
  } catch (e) {
    throw new Error(`Could not retrieve file from S3: ${e.message}`);
  }
};

export const getBase64Text = async (url) => {
  return axios
    .get(url, {
      responseType: "text" /* or responseType: 'arraybuffer'  */,
    })
    .then((r) => "data:image/png;base64," + r.data.toString());
};
